import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';
import { mediaquery } from 'shared/styles/styleFunctions';
import { zIndex } from 'shared/config';

export default css({
  '&.button-selection-input': {},
  '.button-selection-input': {
    '&__search': {
      position: 'relative',
      flexDirection: 'row',
      color: COLORS.NEUTRAL600,
      gap: '8px',
      alignItems: 'center',
      height: '42px',
    },
    '&__search-input': {
      width: '100%',
      margin: 0,
      padding: '0.5rem 0.75rem',
      paddingLeft: '30px',
      paddingRight: '95px',

      fontSize: '1rem',
      border: `1px solid ${COLORS.NEUTRAL300}`,

      borderRadius: '2px',

      '&:placeholder': {
        color: COLORS.NEUTRAL400,
      },
    },
    '&__search-icon': {
      position: 'absolute',
      left: '10px',
      zIndex: zIndex.zForeground,
      top: '12px',
    },
    '&__divider': {
      margin: `${theme.space[4]} 0 ${theme.space[4]} 0`,
    },
    '&__options': {
      flexDirection: 'column',
      gap: '8px',
    },
    '&__option': {
      textAlign: 'left',
      fontWeight: 400,
      backgroundColor: COLORS.WHITE,
    },
    '&__option--selected': {
      backgroundColor: COLORS.PRIMARY50,
      borderColor: COLORS.PRIMARY500,
    },
    '&__option--hidden': {
      display: 'none',
    },
  },
});
